(ns frontend.ui.component.lp-portal.report.body.real-estate.holding.koke.pdf
  (:require
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.esg.pdf :as esg]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.chart.view :as chart-view]))

(defn- portfolio-pages
  [report-data]
  (page/page
   (page/page-title {:page-title (:holding-name report-data) :toc-item true})
   (column/columns
    (column/column
     (card/card
      "Gross investment at cost & Valuation"
      {:svg   (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge
                                     (:figures (:investment-at-cost-valuation report-data))
                                     {:chart {:width  500
                                              :height 300}}))
       :width (- page/page-width-half 70)}
      (text-content/optional-footer (:investment-at-cost-valuation report-data)))
     (card/card
      "Physical occupancy"
      {:svg   (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge
                                     (:figures (:occupancy report-data))
                                     {:chart {:width  500
                                              :height 280}}))
       :width (- page/page-width-half 70)}
      (text-content/optional-footer (:occupancy report-data))))
    (column/column
     (card/card
      "NOI"
      {:svg   (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge
                                     (:figures (:noi report-data))
                                     {:chart {:width  500
                                              :height 280}}))
       :width (- page/page-width-half 70)}
      (text-content/optional-footer (:noi report-data)))
     (card/card
      "Debt Financing"
      {:svg   (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge
                                     (:figures (:debt-financing report-data))
                                     {:chart {:width  500
                                              :height 280}}))
       :width (- page/page-width-half 70)}
      (text-content/optional-footer (:debt-financing report-data)))))))


(defn holding-pages
  [view-data]
  [(portfolio-pages view-data)])


(defn holding-pages-property-esg
  [view-data]
  (concat (holding-pages view-data)
          (esg/esg-pages view-data)))

(defn holding-pages-portfolio-esg
  [view-data]
  (concat (holding-pages view-data)
          (esg/portfolio-esg-pages view-data)))
